import { collectFontUsageFromNodes } from "./FontUsageCollector";
import { loadFont } from "./FontLoader";

export const loadPageFonts = (nodes: Parameters<typeof collectFontUsageFromNodes>[0], targetDocument?: Document) => {
  collectFontUsageFromNodes(nodes).forEach((font) => {
    void loadFont(font.family, font.weight, font.style, targetDocument).catch((): void => undefined);
  });
};
